<template>
  <div class="all_part">
    <div>
      <titleBlock_computer></titleBlock_computer>
    </div>
    <div class="input_button">
      <div class="all_input">
        <div class="all_input_top">
          <div class="input_arrs">
            <div class="input_styles">
              <el-input
                v-model="product_number"
                placeholder="平台编号\询价单号\客户图号"
                style="width: 490px"
              ></el-input>
            </div>
            <div class="submit_button">
              <div class="search_button">
                <div class="sousuoButton">
                  <el-button
                    type="primary"
                    @click="serchChanPin"
                    style="
                      height: 48px;
                      width: 144px;
                      margin-left: 20px;
                      font-size: 16px;
                    "
                    >搜索
                  </el-button>
                  <div class="icon_sou">
                    <img src="../assets/SouSuo.png" alt="" width="14px" />
                  </div>
                </div>
              </div>
              <div class="all_second_button">
                <div class="ChongZhi">
                  <div class="second_button" @click="clearInput">
                    <el-button
                      plain
                      type="primary"
                      style="width: 92px; height: 48px; font-size: 16px"
                      >重置
                    </el-button>
                  </div>
                  <div class="icon_chong">
                    <img src="../assets/ChongZhi.png" alt="" width="14px" />
                  </div>
                </div>
                <div class="second_button">
                  <div class="ShouQi">
                    <div>
                      <el-button
                        plain
                        type="primary"
                        style="width: 92px; height: 48px; font-size: 16px"
                        @click="inputShow"
                      >
                        {{ PanDuanShou ? "收起" : "展开" }}
                      </el-button>
                    </div>
                    <div :class="PanDuanShou ? 'icon_Shou' : 'icon_Shous'">
                      <img src="../assets/ShouQI.png" alt="" width="14px" />
                    </div>
                  </div>
                </div>
                <div class="second_button" @click="clearInput">
                  <div class="Fanhu">
                    <div>
                      <el-button
                        plain
                        type="primary"
                        style="width: 92px; height: 48px"
                        @click="back_menu"
                        >返回
                      </el-button>
                    </div>
                    <div class="icon_fan">
                      <img src="../assets/FanHui.png" alt="" width="14px" />
                    </div>
                  </div>
                </div>
                <div class="second_button">
                  <div>
                    <el-button
                      @click="serchGouWuChe"
                      plain
                      type="primary"
                      style="width: 122px; height: 48px; font-size: 16px"
                      >查看清单
                    </el-button>
                  </div>
                </div>
                <div class="second_button">
                  <div>
                    <el-button
                      @click="download"
                      plain
                      type="primary"
                      style="width: 122px; height: 48px; font-size: 16px"
                      >导出清单
                    </el-button>
                  </div>
                </div>
                <div class="second_button">
                  <div>
                    <el-button
                      @click="clearall"
                      plain
                      type="primary"
                      style="width: 122px; height: 48px; font-size: 16px"
                      >清空清单
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="input_arr" v-if="PanDuanShou">
            <div class="input_style">
              <el-select
                @change="change('a', ChanPinDaLei_choice)"
                v-model="ChanPinDaLei_choice"
                placeholder="产品类别"
                style="width: 150px"
              >
                <el-option
                  v-for="item in ChanPinDaLei_Select"
                  :key="item.value"
                  :label="item.category_big"
                  :value="item.category_big"
                  @click="this.serchChanPinXiaoLei()"
                >
                </el-option>
              </el-select>
            </div>
            <div class="input_style">
              <el-select
                v-model="ChanPinXiaoLei_choice"
                placeholder="产品小类"
                style="width: 150px"
              >
                <el-option
                  v-for="item in ChanPinXiaoLei_Select"
                  :key="item.value"
                  :label="item.category_small"
                  :value="item.category_small"
                >
                </el-option>
              </el-select>
            </div>
            <div class="input_style">
              <el-select
                v-model="CaiZhi_choice"
                placeholder="材质"
                style="width: 150px"
              >
                <el-option
                  v-for="item in CaiZhi_select"
                  :key="item.value"
                  :label="item.material"
                  :value="item.material"
                >
                </el-option>
              </el-select>
            </div>
            <div class="input_style">
              <el-input
                v-model="second_CaiZhi_GongYi"
                placeholder="尺寸描述\特殊工艺\材质描述"
                style="width: 230px"
              ></el-input>
            </div>
            <div class="input_style">
              <el-input
                v-model="newItemNo"
                placeholder="新旧料号 多个查询空格隔开"
                style="width: 230px"
              ></el-input>
            </div>

          </div>
          <div v-if="PanDuanShou">
          </div>
          <div>
          </div>
        </div>
      </div>
    </div>
    <div :class="PanDuanShou == false ? 'table' : 'tables'">
      <!-- 新增行样式绑定 -->
      <el-table
        :data="tableData"
        ref="multipleTable"
        style="width: 100%"
        height="100%"
        border
        row-key="id"
        :tree-props="{ hasChildren: 'hasChildren', children: 'child' }"
        :row-class-name="tableRowClassName"
      >
        <el-table-column type="index" width="120" label="操作" fixed>
          <template slot-scope="scope">
            <el-button @click="TianJiaTest(scope.row)" v-show="scope.row.child"  >
              添加
            </el-button>
            <el-button
              @click="deletess(scope.row)"
              v-if="PanDuanZhuangTai == 2"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          fixed
          prop="oldMaterialNo"
          label="旧料号"
          width="160"
        ></el-table-column>
        <el-table-column
          fixed
          prop="newItemNo"
          label="新料号"
          width="160"
        ></el-table-column>
        <el-table-column
          fixed
          prop="shanghai_stock"
          label="可用数量"
          width="100"
        ></el-table-column>

        <el-table-column
          fixed
          prop="taiwan_stock"
          label="实际在库数量"
          :formatter="pan_Zreo"
          width="150"
        ></el-table-column>

        <el-table-column
          fixed
          prop="quantity_zhongshan"
          label="中山厂库存"
          width="120"
        ></el-table-column>
        <el-table-column
          fixed
          prop="quantity_taiwan"
          label="台湾厂库存"
          width="120"
        ></el-table-column>
        <el-table-column
          fixed
          prop="quantity_thailand"
          label="滞销品库存"
          width="120"
        ></el-table-column>

        <el-table-column
            fixed
            prop="transport"
            label="在途总量"
            width="120"
        ></el-table-column>
        <el-table-column
          fixed
          prop="category_small"
          label="产品小类"
          width="140"
        ></el-table-column>
        <el-table-column
          fixed
          prop="customer_drawing"
          label="客户图号"
          width="140"
        ></el-table-column>
        <el-table-column
          fixed
          prop="dimension_description"
          label="尺寸描述"
          width="140"
        ></el-table-column>
        <el-table-column
          prop="material_description"
          label="材质描述"
          width="140"
        ></el-table-column>
        <el-table-column
          prop="structural"
          label="结构形式"
          width="140"
        ></el-table-column>
        <el-table-column
          prop="special_process "
          label="特殊工艺"
          width="140"
        ></el-table-column>
        <el-table-column prop="MOQ" label="MOQ" width="120"></el-table-column>
        <el-table-column
          prop="packing_quantity"
          label="数量"
          width="120"
        ></el-table-column>
        <el-table-column
          v-if="user_leave.standardTypePrice == 1"
          prop="money"
          label="面价"
          width="140"
        ></el-table-column>
        <el-table-column
          v-if="user_leave.standardTypePrice == 1"
          prop="suggested_price"
          label="分包价"
          width="140"
        ></el-table-column>
        <el-table-column
          v-if="user_leave.standardTypePrice == 1"
          prop="executive_director"
          label="工程师"
          width="140"
        ></el-table-column>
        <el-table-column
          v-if="user_leave.standardTypePrice == 1"
          prop="sales_manager"
          label="主管/客户经理"
          width="140"
        ></el-table-column>
        <el-table-column
          v-if="user_leave.standardTypePrice == 1"
          prop="industry_manager"
          label="部门经理"
          width="140"
        ></el-table-column>
        <el-table-column
          v-if="user_leave.standardTypePrice == 1"
          prop="project_price"
          label="专案价格"
          width="140"
        ></el-table-column>
        <el-table-column
          v-if="user_leave.standardTypePrice == 1"
          prop="mould_cost"
          label="成品模具费/样品模具费"
          width="140"
        ></el-table-column>
        <el-table-column
          v-if="user_leave.standardTypePrice == 1"
          prop="other_expenses"
          label="其他费用"
          width="140"
        ></el-table-column>
        <el-table-column
          v-if="user_leave.standardTypePrice == 1"
          prop="remarks"
          label="其他说明"
          width="120"
        ></el-table-column>
        <el-table-column
          v-if="user_leave.standardTypePrice == 1"
          prop="production_cycle"
          label="生产周期"
          width="140"
        ></el-table-column>
        <el-table-column
          v-if="user_leave.standardTypePrice == 1"
          prop="inquiry_no"
          label="询价单号"
          width="140"
        ></el-table-column>
        <el-table-column
          v-if="user_leave.standardTypePrice == 1"
          prop="product_number"
          label="平台编号"
          width="140"
        ></el-table-column>
        <el-table-column
          v-if="user_leave.standardTypePrice == 1"
          prop="quotation_no"
          label="供应商报价单号"
          width="140"
        ></el-table-column>
      </el-table>
    </div>
    <div class="block">
      <el-pagination
        page-size="20"
        layout="prev, pager, next"
        :total="tableData.total"
        hide-on-single-page="true"
        @current-change="reflash"
      >
      </el-pagination>
    </div>
    <div class="Copyright_information">
      <span>Copyright © 胤舜密封EBD数据平台限内部使用 版权所有</span>
    </div>
  </div>
</template>
<script>
import titleBlock_computer from "../views/titleBlock_computer.vue";
import { httpUrl } from "../components/publics";

export default {
  data() {
    return {
      user_leave: {},
      second_CaiZhi_GongYi: "",
      product_number: "", //平台编号
      PanDuanShou: true,
      tableData: [],
      newItemNo: "", //新料号
      oldMaterialNo: "", //旧料号
      internal_meridian: "", // 产品内径
      wire_diameter: "", //产品线径
      ChanPinXiaoLei_choice: "", //产品小类选择
      CaiZhi_choice: "", //材质选择   //material
      BiaoZhun_Choice: "", //标准选择
      YingDu_Choice: "", //硬度选择
      standard_code: "", //标准代码
      inquiry_no: "", //询价单号
      CaiLiaoXinXi_Code_Choice: "", //材料信息选择
      ChanPinDaLei_choice: "", // 产品大类选择
      YanSe_Choice: "", //颜色选择
      customer_drawing: "", //客户图号选择
      special_process: "", //特殊工艺选择
      dimension_description: "", //尺寸描述
      material_description: "", //材质描述
      structural: "", //结构形式选择
      ChanPinDaLei_Select: [], // 产品大类下拉框
      ChanPinXiaoLei_Select: [], //产品小类下拉框
      CaiZhi_select: [], //材质选择拉下
      BiaoZhun_Select: [], //标准下拉框
      YingDu_Select: [], //硬度下拉框
      CaiLiaoXinXi_Code_Select: [], //材料信息下拉框
      YanSe_Select: [], //颜色下拉框
      page: "",
      PanDuanZhuangTai: "",
    };
  },
  watch: {
    ChanPinDaLei_choice(newName, oldName) {
      this.serchChanPinXiaoLei(newName);
    },
    ChanPinXiaoLei_choice() {
      this.serchCaiZhi();
    },
  },
  mounted() {
    this.getUser();
    this.serchChanPinDaLei();
    this.serchBiaoZhun();
    this.serchYingDu();
    this.serchCaiLiaoXinxi();
    this.serchYanSe();
  },

  methods: {
    getUser() {
      this.user_leave = JSON.parse(sessionStorage.getItem("user"));
      console.log(this.user_leave);
    },
    add(val) {
      this.axios
        .post(
          httpUrl + "/api/index/nonStandardOfferAdd",
          this.$qs.stringify({
            data: val,
          })
        )
        .then((response) => {
          if (response.data.code === 200) {
            this.$message(response.data.message);
            console.log("success", response.data);
          }
        })
        .catch((error) => console.log(error, "error"));
    },
    delete(val) {
      this.axios
        .get(httpUrl + `/api/index/nonStandardOfferStrDel?id=${val}`)
        .then((response) => {
          if (response.data.code === 200) {
            this.serchGouWuChe2();
            this.$message(response.data.message);

            console.log("success", response.data);
          }
        })
        .catch((error) => console.log(error, "error"));
    },
    TianJiaTest(vals) {
      let suser_id = JSON.parse(sessionStorage.getItem("user"));
      let selectID = suser_id.id;

      let arr = [];
      arr.push(vals)
      arr.forEach((element) => {
        element.user_id = selectID;
      });
      let a = {};
      arr.map((val) => {
        delete val.child;
        a = JSON.stringify(val);
      });
      this.add(a);
      console.log(arr);
      console.log(a);
      console.log(this.$refs.multipleTable.selection);
    },
    deletess(vals) {
      let stringTest = this.$refs.multipleTable.tableData;
      stringTest.forEach((element) => {
      });
      let a = {};

      this.delete(vals.id);
      console.log(stringTest);
      console.log(a);
      console.log(this.$refs.multipleTable.selection);
    },
    serchGouWuChe() {
      let suser_id = JSON.parse(sessionStorage.getItem("user"));
      let selectID = suser_id.id;
      console.log(selectID);
      this.axios
        .get(
          httpUrl +
            `/api/index/nonStandardOfferList?page=${this.page}&user_id=${selectID}`
        )
        .then((response) => {
          if (response.data.code == 200) {
            this.PanDuanZhuangTai = 2;

            if (response.data.data.length > 100) {
              this.$message(response.data.message);
            } else {
              response.data.data.map((value, key) => {
                if (value.child.length > 0) {
                  value.child.map((val, num) => {
                    val["id"] = value.id * 10 + num;
                  });
                }
              });
              this.tableData = response.data.data;
            }
          }
          this.$message(response.data.message);
        })
        .catch((error) => console.log(error, "error"));
    },
    serchGouWuChe2() {
      let suser_id = JSON.parse(sessionStorage.getItem("user"));
      let selectID = suser_id.id;
      console.log(selectID);
      this.axios
        .get(
          httpUrl +
            `/api/index/nonStandardOfferList?page=${this.page}&user_id=${selectID}`
        )
        .then((response) => {
          if (response.data.code == 200) {
            this.PanDuanZhuangTai = 2;

            if (response.data.data.length > 100) {
            } else {
              response.data.data.map((value, key) => {
                if (value.child.length > 0) {
                  value.child.map((val, num) => {
                    val["id"] = value.id * 10 + num;
                  });
                }
              });
              this.tableData = response.data.data;
            }
          } else if (response.data.code == 401) {
            this.tableData = [];
          }
        })
        .catch((error) => console.log(error, "error"));
    },
    TianJiaZhanShi() {
      this.axios
        .POST(httpUrl + `/api/index/offerAdd?`, {
          offer_id: this.PanDuanShou,
        })
        .then((response) => {
          if (response.data.code == 200) {
            this.ChanPinXiaoLei_Select = response.data.data;
            console.log(this.tableData.data);
          }
          console.log("success", response.data);
        })
        .catch((error) => console.log(error, "error"));
    },
    clearall() {
      let suser_id = JSON.parse(sessionStorage.getItem("user"));
      let selectID = suser_id.id;
      this.axios
        .get(
          httpUrl +
            `/api/index/nonStandardOfferDel?user_id=${selectID}`
        )
        .then((response) => {
          if (response.data.code === 200) {
            this.serchGouWuChe2();
            this.$message(response.data.message);
            console.log("success", response.data);
          }
        })
        .catch((error) => console.log(error, "error"));
    },
    change(params, val) {
      console.log(params);
      if (params == "a" && val != "") {
        this.ChanPinXiaoLei_choice = "";
        this.CaiZhi_choice = "";
      }
    },
    back_menu() {
      this.$router.push("/second_menuComputer_PriceAndInventory");
    },
    clearInput() {
      this.product_number = "";
      this.second_CaiZhi_GongYi = "";
      this.newItemNo = ""; //新料号
      this.oldMaterialNo = ""; //旧料号
      this.internal_meridian = ""; // 产品内径
      this.wire_diameter = ""; //产品线径
      this.ChanPinXiaoLei_choice = ""; //产品小类选择
      this.CaiZhi_choice = ""; //材质选择   //material
      this.BiaoZhun_Choice = ""; //标准选择
      this.YingDu_Choice = ""; //硬度选择
      this.standard_code = ""; //标准代码
      this.inquiry_no = ""; //询价单号
      this.CaiLiaoXinXi_Code_Choice = ""; //材料信息选择
      this.ChanPinDaLei_choice = ""; // 产品大类选择
      this.YanSe_Choice = ""; //颜色选择
      this.customer_drawing = ""; //客户图号选择
      this.special_process = ""; //特殊工艺选择
      this.dimension_description = ""; //尺寸描述
      this.material_description = ""; //材质描述
      this.structural = ""; //结构形式选择
    },
    inputShow() {
      this.PanDuanShou = !this.PanDuanShou;
    },
    reflash(val) {
      this.page = val;
      this.serchFinanceinfo();
    },
    serchBiaoZhun() {
      this.axios
        .get(httpUrl + `/api/index/standard`)
        .then((response) => {
          if (response.data.code == 200) {
            this.BiaoZhun_Select = response.data.data;
            console.log(this.tableData.data);
          }
          console.log("success", response.data);
        })
        .catch((error) => console.log(error, "error"));
    },
    serchCaiLiaoXinxi() {
      this.axios
        .get(httpUrl + `/api/index/material_number`)
        .then((response) => {
          if (response.data.code == 200) {
            this.CaiLiaoXinXi_Code_Select = response.data.data;
            console.log(this.tableData.data);
          }
          console.log("success", response.data);
        })
        .catch((error) => console.log(error, "error"));
    },
    serchCaiZhi() {
      this.axios
        .get(
          httpUrl +
            `/api/index/non_standard_material?category_small=${this.ChanPinXiaoLei_choice}`
        )
        .then((response) => {
          if (response.data.code == 200) {
            this.CaiZhi_select = response.data.data;
            console.log(this.tableData.data);
          }
          console.log("success", response.data);
        })
        .catch((error) => console.log(error, "error"));
    },
    serchChanPinXiaoLei(val) {
      this.axios
        .get(
          httpUrl +
            `/api/index/non_standard_category?category_big=${val}`
        )
        .then((response) => {
          if (response.data.code == 200) {
            this.ChanPinXiaoLei_Select = response.data.data;
            console.log(this.tableData.data);
          }
          console.log("success", response.data);
        })
        .catch((error) => console.log(error, "error"));
    },
    serchChanPinDaLei() {
      this.axios
        .get(httpUrl + `/api/index/non_category`)
        .then((response) => {
          if (response.data.code == 200) {
            this.ChanPinDaLei_Select = response.data.data;
            console.log(this.tableData.data);
          }
          console.log("success", response.data);
        })
        .catch((error) => console.log(error, "error"));
    },
    serchChanPin() {
      let suser_id = JSON.parse(sessionStorage.getItem("user"));
      let selectID = suser_id.id;
      this.axios
        .get(
          httpUrl +
            `/api/index/nonStandardOffer?newItemNo=${this.newItemNo}&category_big=${this.ChanPinDaLei_choice}&category_small=${this.ChanPinXiaoLei_choice}&material=${this.CaiZhi_choice}&product_number=${this.product_number}&dimension_description=${this.second_CaiZhi_GongYi}&user_id=${selectID}&page=${this.page}`
        )
        .then((response) => {
          if (response.data.code == 200) {
            this.PanDuanZhuangTai = 1;
            if (response.data.data.length > 1000) {
              this.$message(response.data.message);
            } else {
              response.data.data.map((value, key) => {
                if (value.child.length > 0) {
                  value.child.map((val, num) => {
                    val["id"] = value.id * 10 + num;
                  });
                }
              });
              this.tableData = response.data.data;
            }
          }
          this.$message(response.data.message);
        })
        .catch((error) => console.log(error, "error"));
    },
    download() {
      let suser_id = JSON.parse(sessionStorage.getItem("user"));
      let selectID = suser_id.id;
      console.log(selectID);
      this.axios
        .get(
          httpUrl +
            `/api/index/nonStandardOfferList?page=${this.page}&user_id=${selectID}`
        )
        .then((response) => {
          if (response.data.code == 200) {
            window.location.href =
              httpUrl +
              `/api/index/excelUpdateNonStandardOffer?user_id=${selectID}`;
          }
          this.$message(response.data.message);
        })
        .catch((error) => console.log(error, "error"));
    },
    pan_Zreo(row) {
      if (row.taiwan_stock == null) {
        return 0
      } else {
        return row.taiwan_stock
      }
    },
    // 新增行样式判断方法，和上一页逻辑完全一致
    tableRowClassName({ row }) {
      if (row.suggested_price === '停售') {
        return 'row-stop-sale';
      }
      return '';
    }
  },
  components: {
    titleBlock_computer,
  },
};
</script>

<style>
</style>
<style scoped>
.input_arrs {
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 50%;
}
.input_styles {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.all_part {
  min-width: 1920px;
  min-height: 925px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
}

.all_input {
  display: flex;
  flex-direction: column;
  padding: 0 20px;
}

.all_input_top {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 10px 0;
}

.all_input_bottom {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.submit_button {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.all_second_button {
  display: flex;
  flex-direction: row;
  margin-right: 20px;
}

.second_button {
  margin-left: 20px;
}
.table {
  margin-top: 10px;
  height: 70%;
}
.tables {
  margin-top: 10px;
  height: 70%;
}
.Copyright_information {
  margin-bottom: 15px;
}
.input_arr {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;
}
.input_arr_span {
  margin-right: 10px;
  font-size: 14px;
}
.input_style {
  margin-right: 10px;
}
.sousuoButton {
  position: relative;
}
.icon_sou {
  top: 16px;
  left: 40px;
  position: absolute;
}
.ChongZhi {
  position: relative;
}
.icon_chong {
  top: 16px;
  left: 32px;
  position: absolute;
}
.ShouQi {
  position: relative;
}
.icon_Shou {
  top: 14px;
  left: 12px;
  position: absolute;
}
.icon_Shous {
  top: 15px;
  left: 12px;
  position: absolute;
  transform: rotate(180deg);
}
.icon_fan {
  top: 16px;
  left: 12px;
  position: absolute;
}
.Fanhu {
  position: relative;
}

/* 分包价停售整行红色样式，和上一页统一 */
/deep/ .row-stop-sale {
  background-color: #fef0f0 !important;
}
/deep/ .row-stop-sale td {
  background-color: inherit !important;
  color: #f5222d;
}
</style>